<div class="partners">
  <div *ngFor="let responsible of partnerData" class="panel">
    <div class="panel-header" (click)="togglePanel($event)">
      <span class="panel-title p-text-grey-dark">{{
        responsible?.firstName
      }}</span>
      <span
        *ngIf="responsible?.hasCompanyControl"
        class="panel-status p-text-grey"
      >
        <img
          src="assets/image/check-green-icon.svg"
          alt="Assina pela empresa"
          class="icon"
        />
        Assina pela empresa
        <mat-icon class="expand-icon">expand_more</mat-icon>
      </span>

      <span
        *ngIf="!responsible?.hasCompanyControl"
        class="panel-status p-text-grey"
      >
        <img
          src="assets/image/block-icon.svg"
          alt="Não assina pela empresa"
          class="icon"
        />
        Não assina pela empresa
        <mat-icon class="expand-icon">expand_more</mat-icon>
      </span>
    </div>

    <div class="panel-body">
      <div *ngIf="responsible?.hasCompanyControl" class="partner-details p-3">
        <div class="row margin-data">
          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>CPF:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.document | mask : "000.000.000-00" }}
            </div>
          </div>

          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Participação societária:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.participation }}%
            </div>
          </div>

          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Telefone:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{
                responsible?.phoneNumber
                  | mask : "(00) 00000-0000 || (00) 0000-0000"
              }}
            </div>
          </div>

          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>E-mail:</span>
            </div>

            <div class="col-lg-6 col-md-12">{{ responsible?.email }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Endereço:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.address?.line1 }} -
              {{ responsible?.address?.number }} -
              {{ responsible.address?.line2 }} -
              {{ responsible?.address?.line3 }} -
              {{ responsible?.address?.city }} -
              {{ responsible?.address?.state }} -
              {{ responsible?.address?.postalCode | mask : "00000-000" }}
            </div>
          </div>

          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Número de cadastro S.S.N / TIN:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.foreignAccountData?.identificationNumber }}
            </div>
          </div>

          <div class="col-12 d-flex justify-content-end">
            <button
              (click)="downloadAttachmentByName(responsible?.documentFile)"
              class="btn-document-partners"
            >
              Baixar documento do sócio
              <img src="assets/image/download-icon.svg" alt="Baixar" />
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!responsible?.hasCompanyControl" class="partner-details p-3">
        <div class="row">
          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>CPF:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.document | mask : "000.000.000-00" }}
            </div>
          </div>

          <div class="col-lg-6 mb-2 col-md-12 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Participação societária:</span>
            </div>

            <div class="col-lg-6 col-md-12">
              {{ responsible?.participation }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="panel">
    <div class="panel-header" (click)="togglePanel($event)">
      <span class="panel-title p-text-grey-dark">Ana Maria</span>
      <span class="panel-status p-text-grey">
        <img
          src="assets/image/check-green-icon.svg"
          alt="Assina pela empresa"
          class="icon"
        />
        Assina pela empresa
        <mat-icon class="expand-icon">expand_more</mat-icon>
      </span>
    </div>
    <div class="panel-body">
      <div class="partner-details p-3">
        <div class="row">
          <div class="col-4 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>CPF:</span>
            </div>

            <div class="col-lg-6 col-md-12">755.024.470-73</div>
          </div>

          <div class="col-4 p-text-grey">
            <div class="col-lg-6 col-md-12">
              <span>Participação societária:</span>
            </div>

            <div class="col-lg-6 col-md-12">24%</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
